import type { VehicleBlueprint } from "../types/VehicleBlueprint.js";
import type { WeaponStats } from "./WeaponStats.js";

/**
 * Map a blueprint's weapon fields to a base WeaponStats object.
 *
 * range and projectileLifetimeMs are read directly from the blueprint (each
 * weapon archetype defines its own intended travel distance and lifetime).
 * computeWeaponStats can then apply upgrade multipliers and re-derive
 * projectileLifetimeMs from (range / speed) × 1000.
 */
export function blueprintToBaseWeaponStats(blueprint: VehicleBlueprint): WeaponStats {
  const { damage, reloadMs, projectileSpeed, range, projectileLifetimeMs } = blueprint.weapon;
  return { damage, reloadMs, projectileSpeed, range, projectileLifetimeMs, streams: 1 };
}
